export enum DurationUnitEnum {
  MONTHS = 'Months',
  YEARS = 'Years',
}
